import i18n from 'app/i18n';
import { getLabelForRole } from 'app/agreements/roles';
import { MentorRole } from 'app/agreements/types';

export function getAgreementHeading(role: MentorRole): string {
  const roleType = getLabelForRole(role);

  return i18n.t('agreements.externalAgreement', { roleType });
}
